/**
 * Schedule Event Bus
 *
 * Centralised event bus for all schedule-page interactions.
 */
import Vue from 'vue';

export const scheduleEventBus = new Vue();

export const SCHEDULE_EVENTS = {
  /** Open the "Build Your Personalized Schedule" modal */
  OPEN_MODAL: 'open-personalized-schedule-modal',
  /** Open the Share modal */
  // payload: { triggerEl: HTMLElement } — anchor for SharePopover positioning
  OPEN_SHARE: 'open-share-modal',
  /** Trigger browser print dialog for the schedule listing (payload: { scope }) */
  PRINT_SCHEDULE: 'print-schedule',
  /** Trigger browser print dialog for a single session detail (payload: { session }) */
  PRINT_SESSION: 'print-session',
  /** Navigate from detail view back to listing view (deep-link safe) */
  NAVIGATE_LISTING: 'navigate-listing',
};
